export default (id = '') => ({
  '@click.prevent.stop'() {
    // console.log(this, id);

    window.klaviyo?.openForm(id);
    return;

    /*
     * HACK:
     * I couldn't trigger a form to open twice.
     * So I keep track of the opened forms in the store and if the form was
     * already opened, I trigger a click on the button to open it again.
     */
    if (this.$store.klaviyoFormsOpenend.includes(id)) {
      document.querySelector('.needsclick[data-testid="animated-teaser"] [role="button"]').click();
    }
    else {
      klaviyo?.openForm(id);
      this.$store.klaviyoFormsOpenend.push(id);
    }
  }
});
